import {
  Filter,
  OrdersModeFilter,
  OrdersProductFilter,
  OrdersSalesTermsFilter,
  OrdersShipFromFilter,
  OrdersShipToFilter,
  OrdersStatusFilter,
  OrdersCreateDateFilter,
} from "components/Filters";

const ordersFilters: Filter[] = [
  { key: "createDate", component: OrdersCreateDateFilter },
  { key: "product", component: OrdersProductFilter },
  { key: "shipFrom", component: OrdersShipFromFilter },
  { key: "shipTo", component: OrdersShipToFilter },
  { key: "mode", component: OrdersModeFilter },
  { key: "salesTerms", component: OrdersSalesTermsFilter },
  { key: "status", component: OrdersStatusFilter },
];

export default ordersFilters;
